import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Alcool au volant et prise de médicament - Qu'est-ce que dit la loi?"
            description="Vous êtes intercepté au volant d’un véhicule et vous avez récemment consommé des médicaments? Avocats Alcool au volant vous explique s’il s’agit de capacités affaiblies selon la loi."
            fr={undefined}
            lawType="criminal"
            specialtyText="spécialisé en alcool au volant">
            <p>
                Vous le savez probablement que la consommation d’alcool et de
                drogue est interdite lorsque vous prenez le volant. Néanmoins,
                la <strong>prise de médicaments</strong> peut aussi affaiblir
                vos facultés à conduire.
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Puis-je conduire après avoir consommé des médicaments?"
                    alt=""
                />
            </p>
            <p>
                Par conséquent, si un policier vous intercepte et juge que les
                médicaments que vous avez consommés font en sorte que vous
                n’avez pas les facultés pour conduire, vous pourriez être
                arrêté.
            </p>
            <p>
                <strong>
                    Voici ce qu’il faut comprendre de la conduite avec les
                    facultés affaiblies par la consommation de médicaments!
                </strong>
            </p>
            <h2>Quels sont les effets des médicaments sur ma conduite?</h2>
            <p>
                Tout dépendamment des médicaments qui vous ont été prescrits,
                certain peuvent en effet diminuer vos capacités à conduire un
                véhicule, notamment en causant:
            </p>
            <ul>
                <li>de la somnolence,</li>
                <li>une vision floue,</li>
                <li>des étourdissements,</li>
                <li>des pertes de mémoire, ou</li>
                <li>une baisse de concentration.</li>
            </ul>
            <p>
                Ce sera notamment le cas des médicaments tranquillisants, des
                antidépresseurs, des somnifères, des décongestionnants, des
                relaxants musculaires et des antihistaminiques. En fait, si le
                médicament permet de calmer une douleur, il faut être prudent
                avant de conduire.
            </p>
            <p>
                <strong>
                    Vous n’êtes pas certain des effets de vos médicaments?
                </strong>{' '}
                Dans ce cas, il est recommandé de consulter un médecin ou un
                pharmacien afin de connaître tous les effets des médicaments et
                leurs impacts sur votre conduite automobile.
            </p>
            <h2>
                Intercepté pour conduite avec les facultés affaiblies – Que se
                passe-t-il?
            </h2>
            <p>
                Peu importe la quantité que vous avez consommé, un policier peut
                vous arrêter s’il a des <strong>motifs raisonnables </strong>de
                croire que vos capacités de conduire sont affaiblies par l’une
                ou l’autre des substances suivantes:
            </p>
            <ul>
                <li>Alcool,</li>
                <li>Drogue,</li>
                <li>Médicament.</li>
            </ul>
            <p>
                <strong>Bon à savoir!</strong> Bien souvent, la combinaison de
                certaines substances (médicament et alcool par exemple) amplifie
                les effets sur vos capacités à conduire un véhicule automobile.
            </p>
            <p>
                L’arrestation pourra avoir lieu sur-le-champ et le policier
                n’aura pas l’obligation de procéder à des tests quelconques.
                Dans ce cas, il n’y a pas de question de limites minimales de
                consommation.{' '}
            </p>
            <p>
                Si le <strong>policier soupçonne </strong>que vous avez consommé
                certaines substances qui ont un impact sur votre conduite, il
                pourra vous soumettre à des épreuves de coordination des
                mouvements.<strong> </strong>Si vous échouez les tests, le
                policier pourra alors procéder à votre arrestation.{' '}
            </p>
            <h3>
                Quelles sont les conséquences de la conduite avec les facultés
                affaiblies?
            </h3>
            <p>
                Peu importe la substance que vous avez consommée, les
                conséquences de la conduite avec les facultés affaiblies seront
                les mêmes. Tout d’abord, votre permis de conduire sera suspendu
                pour une <strong>période de 90 jours</strong>.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Qu’est-ce que la conduite avec les facultés affaiblies?"
                    alt=""
                />
            </p>
            <p>
                Ensuite, s’il s’agit de votre deuxième infraction dans une
                période de 10 ans (ce qu’on appelle une récidive), votre
                véhicule sera également saisi pour une durée de 90 jours.{' '}
            </p>
            <p>
                Lorsque vous serez déclaré coupable, votre permis de conduire
                sera révoqué et des conditions devront être remplies si vous
                souhaitez le récupérer à nouveau. Il faut également prendre les
                conséquences connexes, notamment le casier judiciaire et
                l’augmentation de la prime d’assurance.
            </p>
            <p>
                Vous devrez également payer une{' '}
                <strong>amende minimale de 1 000 $. </strong>Toutefois,{' '}
                <Link to="https://avocatsalcoolauvolant.ca/cout-accusation-conduite-facultes-affaiblies/">
                    les coûts réels
                </Link>
                , incluant les frais d’avocat et plusieurs autres frais, seront
                nettement plus élevés. Cela est d’autant plus vrai s’il ne
                s’agit pas de votre première arrestation.
            </p>
            <h3>Puis-je refuser de passer les tests de coordination?</h3>
            <p>
                Non. Si vous omettez ou refusez de vous soumettre à un test que
                le policier vous a demandé d’effectuer, vous serez également mis
                en état d’arrestation. Le refus d’obtempérer est également une{' '}
                <strong>infraction criminelle</strong> qui entraîne des
                sanctions importantes.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Puis-je refuser des tests de coordination?"
                    alt=""
                />
            </p>
            <p>
                Voici à quoi vous vous exposez si vous refusez d’obéir à un
                ordre d’un policier et à un test de coordination:
            </p>
            <ul>
                <li>
                    Suspension immédiate de permis pour une période de 90 jours,
                </li>
                <li>Saisie immédiate du véhicule pour 30 jours,</li>
                <li>
                    Programme d’évaluation et de réduction du risque de conduite
                    avec les facultés affaiblies, et
                </li>
                <li>Révocation du permis après déclaration de culpabilité.</li>
            </ul>
            <p>
                En fait, les conséquences sont bien souvent plus importantes que
                celles associées avec une arrestation pour conduite avec les
                facultés affaiblies.
            </p>
            <h2>Dois-je conduire le véhicule pour être arrêté?</h2>
            <p>
                On pense souvent qu’il faut être au volant du véhicule pour être
                arrêté pour conduite avec les facultés affaiblies. Toutefois, la
                loi interdit également à une personne ayant des facultés
                affaiblies d’avoir{' '}
                <Link to="https://avocatsalcoolauvolant.ca/accusation-garde-controle-alcool/">
                    <strong>la garde ou le contrôle</strong>
                </Link>{' '}
                du véhicule.{' '}
            </p>
            <p>
                <strong>
                    Qu’est-ce qu’un entend par « garde ou contrôle »?
                </strong>{' '}
                Plusieurs situations peuvent être incluses dans une telle
                situation, notamment:
            </p>
            <ul>
                <li>
                    être assis dans le siège conducteur alors que le véhicule
                    est à l’arrêt,
                </li>
                <li>
                    être dans le véhicule (même sur la banquette arrière) et
                    avoir accès aux clés, ou
                </li>
                <li>
                    être près du véhicule (pour mettre des objets dans le coffre
                    ou pour le déneiger).
                </li>
            </ul>
            <p>
                Ce sera au policier qui vous interprétera de déterminer si vous
                aviez une <strong>intention de conduire </strong>le véhicule ou
                non.{' '}
            </p>
            <p>
                <strong>
                    Arrêté pour conduite avec les facultés affaiblies? Avocats
                    Alcool au Volant vous permet de trouver l’avocat qu’il vous
                    faut!
                </strong>
            </p>
            <h2>
                Défendez-vous grâce à un avocat partenaire d’Avocats Alcool au
                Volant!
            </h2>
            <p>
                Une fois que vous êtes intercepté par un policier, certaines
                conséquences vont automatiquement s’appliquer à vous. Néanmoins,
                les sanctions les plus graves ne sont qu’une fois la déclaration
                de culpabilité prononcée par les tribunaux.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="À quoi sert un avocat spécialisé en droit criminel?"
                    alt=""
                />
            </p>
            <p>
                Ainsi, dès que vous êtes en état d’arrestation, il est
                préférable de faire appel à un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-criminel-alcool-volant/">
                    avocat spécialisé en droit criminel
                </Link>
                . Ce dernier pourra d’abord veiller à ce que vos droits soient
                protégés tout au long du processus.
            </p>
            <p>
                Il pourra également mettre en place une défense solide et vous
                représenter devant les tribunaux si votre dossier s’y rend.{' '}
            </p>
            <p>
                <strong>
                    Trouvez l'avocat qu’il vous faut gratuitement grâce au
                    formulaire en ligne ci-dessous!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "conduite-consommation-medicaments/conduire-apres-medicaments.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "conduite-consommation-medicaments/conduite-facultés-affaiblies.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "conduite-consommation-medicaments/refus-test-coordination.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "conduite-consommation-medicaments/utilite-avocat-criminaliste.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
